// extracted by mini-css-extract-plugin
export default {"stepPreviewResult__wrapper":"vFr4bQTtcTJwrmVvCGRM"};